module.exports = __webpack_public_path__ + "img/34800.1751fdfc.jpg";